import React, { useEffect, useState } from "react";
import {
  CustomPropertyInput,
  CustomPropertyInputItem,
} from "ui/CustomProperty";
import { CPTextTypeProps } from "../types";

const InputCustomProp: React.FC<CPTextTypeProps> = ({
  name,
  codeName,
  required,
  permissions,
  isWidget,
  tabIndex,
  regexp,
  regexpText,
  changeable,
  customPropertyId,
  keyId,
  parentKey,
  onChange,
  value,
  isError,
}) => {
  const [valid, setValid] = useState(true);

  useEffect(() => {
    if (isError !== undefined && required) {
      setValid(!isError);
    }
  }, [isError]);

  const validate = (checkedValue: string): boolean => {
    const isEmpty = checkedValue.trim() === "";
    let isValid = true;
    const fieldName = name;

    if (required) {
      isValid = !isEmpty;
      if (isEmpty) {
        console.log(
          `Поле "${fieldName}" не заполнено, оно является обязательным для заполнения`
        );
      }
    }

    if (regexp && !isEmpty) {
      let re = new RegExp(regexp);
      if (!re.test(checkedValue)) {
        console.log(`Поле "${fieldName}" заполнено некорректно`);
        isValid = false;
      }
    }

    setValid(isValid);
    return isValid;
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    validate(newValue);
    onChange({
      customPropertyCode: codeName,
      value: 0,
      customPropertyId: String(customPropertyId),
      text: newValue,
      key: keyId,
      parentKey: parentKey,
    });
  };

  const isDisabled =
    (isWidget && !changeable) ||
    !permissions.includes(`CustomProperty_${codeName}`);

  return (
    <CustomPropertyInputItem
      isWidget={!!isWidget}
      valid={valid}
      name={name}
      required={required}
      disabled={isDisabled}
    >
      <CustomPropertyInput
        isWidget={!!isWidget}
        value={value?.text || ""}
        onChange={handleChange}
        disabled={isDisabled}
        valid={valid}
        regexpText={regexpText}
        tabIndex={tabIndex}
      />
    </CustomPropertyInputItem>
  );
};

export default InputCustomProp;
